import { z } from "zod";

export const Roles = {
  BillingAdmin: "billing_admin",
  ClinicPartner: "clinic_partner",
  HCPAdmin: "hcp_admin",
  Patient: "patient",
  Therapist: "therapist",
} as const;

export const RoleSchema = z.enum([
  Roles.BillingAdmin,
  Roles.ClinicPartner,
  Roles.HCPAdmin,
  Roles.Patient,
  Roles.Therapist,
]);
export type Role = z.infer<typeof RoleSchema>;
